module.exports = __webpack_public_path__ + "allegro-auctions.svg?ab5f9b2f3afba2dc62e294c6f035eb56";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/allegro-auctions.svg
// module id = 275
// module chunks = 2